import { useEffect } from "react";
import { useImmer } from "use-immer";
import { errorMessage, successMessage } from "../../../utils";
import {
  getTenantThemeSettingsApi,
  updateTenantThemeSettingsApi,
} from "../apis/themeApis";

export const useThemeConfig = () => {
  const [state, setState] = useImmer({
    formData: {},
    isLoading: true,
    isSubmitting: false,
    hasChanges: false,
  });

  useEffect(() => {
    const fetchThemeSettings = async () => {
      try {
        const response = await getTenantThemeSettingsApi();

        if (response?.success) {
          setState((draft) => {
            draft.formData = response.data;
          });
        } else {
          errorMessage(response?.message || "Failed to load theme settings");
        }
      } catch (error) {
        errorMessage(
          error.response?.data?.message ||
            error.message ||
            "Failed to load theme settings",
        );
      } finally {
        setState((draft) => {
          draft.isLoading = false;
        });
      }
    };

    fetchThemeSettings();
  }, [setState]);

  const onColorChange = (event) => {
    const { name, value } = event.target;
    setState((draft) => {
      draft.formData[name] = value;
      draft.hasChanges = true;
    });
  };

  const onDisplayChange = (section, platform, field, value) => {
    setState((draft) => {
      draft.formData[section][platform][field] = value;
      draft.hasChanges = true;
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      setState((draft) => {
        draft.isSubmitting = true;
      });

      const response = await updateTenantThemeSettingsApi(state.formData);
      if (response?.success) {
        setState((draft) => {
          draft.formData = response.data
          draft.hasChanges = false;
        });
        successMessage(
          response.message || "Theme settings updated successfully",
        );
      } else {
        errorMessage(response?.message || "Failed to update theme settings");
      }
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to update theme settings",
      );
    } finally {
      setState((draft) => {
        draft.isSubmitting = false;
      });
    }
  };

  return { state, onColorChange, onDisplayChange, onSubmit };
};
